import tw, { styled } from 'twin.macro';

const FormHeading = styled.h3`
  ${tw`mt-0 mb-4 font-semibold`}
`;

export default FormHeading;
